/* eslint-disable react-hooks/exhaustive-deps */
import SlideModal from "../../../../components/slide-modal";
import {
  FC,
  useEffect,
  useState,
  useMemo,
  HTMLProps,
  useRef,
  ChangeEvent,
} from "react";
import ChevronRightIcon from "@ht/shared/fonts/deos-pis/chevron-right";
import { Button, ScrollBar } from "@ht/components";
import TreeTable from "../BroadcastTable/index";
import useFetchUserList from "../../hooks/useFetchUserList";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import ArrowLeftIcon from "@ht/shared/fonts/deos-pis/arrow-left";
import { startBroadcastAgentChat } from "../../../../app/chatAgent/chatAgentSlice";
import { TInput } from "@ht/components/src/forms/form-elements/types";
import { useHttpRequest } from "../../../../hooks/useHttpRequest";
export interface IModal {
  visible: boolean;
  onClose: () => void;
  onSend: (broadcastCount: number) => void;
}

const IndeterminateCheckbox = ({
  indeterminate,
  className = "",
  ...rest
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (typeof indeterminate === "boolean") {
      if (ref.current)
        ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate]);

  return (
    <input
      type="checkbox"
      ref={ref}
      className={`${className} cursor-pointer accent-primary`}
      {...rest}
    />
  );
};

const BroadcastModal: FC<IModal> = ({ onClose, visible, onSend }) => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);
  const [showFirstModal, setShowFirstModal] = useState<any>();
  const [showFinishModal, setShowFinishModal] = useState<any>();
  const [selected, setSelected] = useState<Array<any>>([]);
  const [textAreaCount, setTextAreaCount] = useState(0);
  const [valueMessage, setValueMessage] = useState<string>("");
  const [listHierarchy, setListHierarchy] = useState<Array<any>>([]);

  const searchKeyword = "";

  const { results } = useFetchUserList({
    tenantid: user ? user?.tenantId : "",
    agentUsername: user?.username,
  });

  const chatAgentServiceUrl = process.env.REACT_APP_CHAT_AGENT_SERVICE;
  const { sendRequest } = useHttpRequest(chatAgentServiceUrl);

  const loadUser = async () => {
    const url = `/UserHierarchy/${user?.tenantId}/?username=${user?.username}&keyword=${searchKeyword}`;

    let responseData = [];

    if (user?.username) {
      const response = await sendRequest({
        url,
        method: "get",
      });

      responseData = response.data;
    }

    setListHierarchy(responseData);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (user?.tenantId)
        loadUser().catch((e) => console.log("loadUser err", e.message));
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [searchKeyword, user]);

  useEffect(() => {
    if (visible && user?.tenantId)
      loadUser().catch((e) => console.log("loadUser err", e.message));
  }, [user, visible]);

  const arrayToTree = (array: any, parent: string) =>
    array
      .filter((item: any) => item.leader_id === parent)
      .map((child: any) => ({
        ...child,
        children: arrayToTree(array, child.id),
      }));

  const tree = useMemo(() => {
    return arrayToTree(listHierarchy, String(user?.userId));
  }, [listHierarchy]);

  const userFullNameCell = (props: any) => {
    return (
      <div
        className="pl-5"
        style={{
          paddingLeft: `${props.row.depth * 2}rem`,
        }}
      >
        <div className="font-semibold text-gray-700">
          <div className="flex space-x-3 items-center">
            {props.row.getCanExpand() ? (
              <button
                {...{
                  onClick: props.row.getToggleExpandedHandler(),
                  style: { cursor: "pointer" },
                }}
              >
                {props.row.getIsExpanded() ? (
                  <ChevronRightIcon className="rotate-90 text-gray-400" />
                ) : (
                  <ChevronRightIcon className="text-gray-400" />
                )}
              </button>
            ) : (
              <div className="items-center w-fit">
                <div className="rounded-full w-2 h-2 bg-gray-400"></div>
              </div>
            )}
            <div className="flex w-full">
              <button
                className="w-full py-1 flex items-center gap-x-2 font-semibold"
                onClick={props.row.getToggleSelectedHandler()}
              >
                <IndeterminateCheckbox
                  {...{
                    checked: props.row.getIsSelected(props.row.original.id),
                    indeterminate: props.row.getIsSomeSelected(),
                    onChange: props.row.getToggleSelectedHandler(),
                  }}
                />{" "}
                <div className="space-x-2 order-2">
                  <span className="bg-purple-50 px-1.5 py-1 rounded-[4px] text-primary">
                    {props.row.original.role_name}
                  </span>
                  <span>{props.row.original.fullname}</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const headerSelection = ({ table }: any) => (
    <button
      className="text-gray-700 flex items-center gap-x-2 w-full font-semibold hover:text-gray-400"
      onClick={table.getToggleAllRowsSelectedHandler()}
    >
      <IndeterminateCheckbox
        {...{
          checked: table.getIsAllRowsSelected(),
          indeterminate: table.getIsSomeRowsSelected(),
          onChange: table.getToggleAllRowsSelectedHandler(),
        }}
      />
      {"All"}
    </button>
  );
  const columns = useMemo(
    () => [
      {
        id: "selection",
        header: headerSelection,
        accessorKey: "id",
        cell: userFullNameCell,
      },
    ],
    []
  );

  const handleOnSelect = () => {
    setShowFirstModal(false);
    setShowFinishModal(true);
  };

  const handleInputValueChange = (e: ChangeEvent<TInput>) => {
    setTextAreaCount(e.target.value.length);
    setValueMessage(e.target.value);
  };

  const handleBackButton = () => {
    setShowFirstModal(true);
    setShowFinishModal(false);
  };

  const handleCloseFinishModal = () => {
    setShowFinishModal(false);
    setShowFirstModal(false);
    onClose();
  };

  const handleSendButton = () => {
    dispatch(
      startBroadcastAgentChat({
        tenantId: user?.tenantId,
        deviceId: user?.deviceId,
        toUserNames: selected.map((a) => a.username),
        content: {
          type: "TEXT",
          message: valueMessage,
          files: [],
        },
      })
    );
    setShowFinishModal(false);
    setShowFirstModal(false);
    onSend(selected.length);
    setValueMessage("");
    onClose();
  };

  useEffect(() => {
    setShowFirstModal(visible);
    setValueMessage("");
  }, [visible]);

  useEffect(() => {
    setListHierarchy(results);
  }, [results]);

  return (
    <>
      <SlideModal
        title="Broadcast To"
        onClose={onClose}
        visible={showFirstModal}
        direction="RIGHT_TO_LEFT"
        className="h-[89vh] xxsToXs:w-[97%] xsToSm:w-[97%] top-14 w-[530px]"
      >
        <div className="flex flex-col items-end gap-4 w-full h-[calc(95vh_-_55px)]">
          <div className="w-full h-[75%]">
            <ScrollBar>
              <TreeTable
                columns={columns}
                data={tree}
                isLoading={false}
                totalRows={1000}
                // pageSize={pageSize}
                hiddenColumns={[]}
                classNameBody="h-11"
                // pageSizeChangeHandler={setPageSize}
                onSelectRow={(rows) => setSelected(rows)}
                onVisible={visible}
              />
            </ScrollBar>
          </div>
          <div className="w-full h-[1px] bg-gray-200"></div>
          <div className="flex items-end py-0.5 ">
            {selected.length > 0 ? (
              <Button
                type="submit"
                hover={false}
                label="Select"
                variant="texted"
                onClick={handleOnSelect}
                color={"primary"}
                className={
                  "py-2.5 px-4 !bg-primary h-fit w-[220px] rounded-lg text-md font-bold !text-white order-6"
                }
              >
                Select
              </Button>
            ) : (
              <Button
                color={"light"}
                disabled={true}
                className={
                  "py-2.5 px-4 !bg-gray-200 h-fit w-[220px] rounded-lg text-md !font-bold !text-gray-400 font"
                }
              >
                Select
              </Button>
            )}
          </div>
        </div>
      </SlideModal>
      <SlideModal
        title="Broadcast Message"
        onClose={handleCloseFinishModal}
        visible={showFinishModal}
        direction="RIGHT_TO_LEFT"
        className="h-[89vh] xxsToXs:w-[97%] xsToSm:w-[97%] top-14 w-[500px]"
      >
        <div className="flex flex-col items-end gap-4 w-full h-[calc(90vh_-_55px)]">
          <div className="w-full h-fit">
            <div className="flex flex-row w-full h-fit items-center">
              <div className="flex flex-col w-full h-fit items-start">
                <div className="text-base font-bold text-gray-700 w-fit h-fit">
                  Message
                </div>
                <div className="flex flex-row items-center text-gray-700 py-2 px-3 bg-gray-100 gap-2.5 w-full h-fit rounded-md">
                  <textarea
                    className="w-full h-full bg-gray-100 focus:outline-none resize-none placeholder:text-gray-400 text-md"
                    placeholder="Write message here..."
                    rows={7}
                    maxLength={256}
                    onChange={handleInputValueChange}
                    value={valueMessage}
                  />
                </div>
                <div className="text-base font-semibold text-gray-400 self-end">
                  {textAreaCount}/256
                </div>
              </div>
            </div>
          </div>
          <div className="w-full h-[1px] bg-gray-200"></div>
          <div className="flex items-end py-0.5 gap-4">
            <Button
              className="box-border flex flex-row items-center justify-center p-2.5 gap-2.5 w-fit h-fit bg-white border-gray-200 rounded-lg border-[1px]"
              onClick={handleBackButton}
            >
              <ArrowLeftIcon className="w-5 h-5 text-gray-400" />
            </Button>
            {textAreaCount > 0 &&
              valueMessage != "" &&
              selected.length >= 1 ? (
              <Button
                type="submit"
                hover={false}
                label="Select"
                variant="texted"
                onClick={() => handleSendButton()}
                color={"primary"}
                className={
                  "py-2.5 px-4 !bg-primary h-fit w-[220px] rounded-lg text-md font-bold !text-white order-6"
                }
              >
                Send
              </Button>
            ) : (
              <Button
                disabled={true}
                color={"light"}
                className={
                  "py-2.5 px-4 !bg-gray-200 h-fit w-[220px] rounded-lg text-md font-bold !text-gray-400  order-6"
                }
              >
                Send
              </Button>
            )}
          </div>
        </div>
      </SlideModal>
    </>
  );
};

export default BroadcastModal;
